import React from 'react';

const Partners = () => {
    // Using real client logos from the public directory
    const partners = [
        { name: 'Bell', logo: '/clientLogos/bell-logo.svg' },
        { name: 'Aecon', logo: '/clientLogos/aecon-logo.svg' },
        { name: 'Oracle', logo: '/clientLogos/oracle_logo.png' },
        // Repeat for seamless scrolling effect
        { name: 'Bell', logo: '/clientLogos/bell-logo.svg' },
        { name: 'Aecon', logo: '/clientLogos/aecon-logo.svg' },
        { name: 'Oracle', logo: '/clientLogos/oracle_logo.png' },
        { name: 'Bell', logo: '/clientLogos/bell-logo.svg' },
        { name: 'Aecon', logo: '/clientLogos/aecon-logo.svg' },
        { name: 'Oracle', logo: '/clientLogos/oracle_logo.png' },
    ];

    return (
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Technology <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">Partners</span>
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Collaborating with industry leaders to deliver exceptional solutions
                    </p>
                </div>

                {/* Scrolling Logos Container */}
                <div className="relative">
                    {/* Gradient Overlays */}
                    <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
                    <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

                    {/* Scrolling Track */}
                    <div className="overflow-hidden">
                        <div className="flex animate-scroll">
                            {/* Partner logos */}
                            {partners.map((partner, index) => (
                                <div
                                    key={index}
                                    className="flex-shrink-0 mx-8 flex items-center justify-center"
                                >
                                    <div className="w-44 h-24 bg-white rounded-xl border border-gray-200 flex items-center justify-center hover:border-blue-300 hover:shadow-lg transition-all duration-300 px-6">
                                        <img
                                            src={partner.logo}
                                            alt={partner.name}
                                            className="max-h-16 w-auto object-contain transition-all duration-300"
                                        />
                                    </div>
                                </div>
                            ))}
                            {/* Duplicate for seamless loop */}
                            {partners.map((partner, index) => (
                                <div
                                    key={`dup-${index}`}
                                    className="flex-shrink-0 mx-8 flex items-center justify-center"
                                >
                                    <div className="w-44 h-24 bg-white rounded-xl border border-gray-200 flex items-center justify-center hover:border-blue-300 hover:shadow-lg transition-all duration-300 px-6">
                                        <img
                                            src={partner.logo}
                                            alt={partner.name}
                                            className="max-h-16 w-auto object-contain transition-all duration-300"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Animation Styles */}
            <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 10s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
        </section>
    );
};

export default Partners;
